import { useState } from "react";
import { toast } from "react-toastify";
import { post } from "../_services/apiService";
import { endpoints } from "../_config";

const ProductTemplate = (props) => {
    const {
        productOrderItemData,
        productOrderData,
        isPriceAdded = false,
        setPrice,
        handleAddPrice,
        price = "",
        onPriceUpdate,
        onEditingChange,
        onProductPriceUpdate,
    } = props;

    const [editingPrice, setEditingPrice] = useState(false);
    const [tempPrice, setTempPrice] = useState("");
    const [priceLoading, setPriceLoading] = useState(false);

    const handleUpdatePrice = async () => {
        if (!tempPrice) {
            toast.warning("Please enter price");
            return;
        }

        setPriceLoading(true);

        try {
            const response = await post(endpoints.UpdateQuotationCustomPrice, {
                quotationId: productOrderData.quotationId,
                custom_price: Number(tempPrice)
            });

            if (response.isSuccess === 200) {
                toast.success("Price updated successfully");
                const updatedPrice = Number(tempPrice);
                setEditingPrice(false);
                setTempPrice("");
                if (onEditingChange) {
                    onEditingChange(false);
                }
                // Update the productOrderData immediately for instant reflection
                if (onProductPriceUpdate) {
                    onProductPriceUpdate(updatedPrice);
                }
                // Refresh the parent component data
                if (onPriceUpdate) {
                    onPriceUpdate();
                }
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setPriceLoading(false);
        }
    };

    const handleInlineEdit = () => {
        setEditingPrice(true);
        setTempPrice(String(productOrderData?.price || ""));
        if (onEditingChange) {
            onEditingChange(true);
        }
    };

    const handleCancelEdit = () => {
        setEditingPrice(false);
        setTempPrice("");
        if (onEditingChange) {
            onEditingChange(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleUpdatePrice();
        } else if (e.key === 'Escape') {
            handleCancelEdit();
        }
    };

    return (

        <div >

            {productOrderItemData != null ?
                <section>
                    <div>
                        <div className="container mt-5">
                            <header className="d-flex justify-content-between header_weepr">
                                <div className="logo">
                                    <img src="images/logo-white.png" alt="" />
                                </div>
                                <div className="header_text">
                                    <h2>QUOTATION</h2>
                                    <p><strong>Number:</strong> {productOrderItemData.orderNo}</p>
                                    <p><strong>Date:</strong> {productOrderItemData.orderDate}</p>
                                </div>
                            </header>

                            <div className="all_main_wepper">
                                <div className="client-details">
                                    <strong>QUOTATIONTO:</strong>
                                    <h3>{productOrderItemData.name}</h3>
                                    {/* <span>Managing Director ,Company ltd.</span> */}
                                    <p><strong>Phone:</strong>{productOrderItemData.mobileNo}</p>
                                    <p><strong>Email:</strong>{productOrderItemData.emailId}</p>
                                </div>

                                <div className="quotation-details mt-4">
                                    <p><strong>Dear Client,</strong></p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.</p>

                                </div>


                                <div className="mt-4">

                                    <div className="product-header">
                                        <div className="product-no"><strong>No.</strong></div>
                                        <div className="product-description"><strong>PRODUCT DESCRIPTION</strong></div>
                                        <div className="price"><strong>PRICE</strong></div>
                                        <div className="quantity"><strong>QUANTITY</strong></div>
                                        <div className="total"><strong>TOTAL</strong></div>
                                    </div>


                                    {productOrderItemData?.orderItem?.map((item, index) => (

                                        <div className="product-row">
                                            <div className="product-no">01</div>
                                            <div className="product-description">
                                                {item.productName}<br />
                                                <small>Categories: {item.productSubCategoryName}, {item.categoryName}</small>
                                            </div>
                                            <div className="price">{item.unitPrice}</div>
                                            <div className="quantity">{item.quantity}</div>
                                            <div className="total">${item.totalAmount}</div>
                                        </div>

                                    ))}





                                </div>


                                <div className="terms mt-4">
                                    <div className="terms-conditions-row">
                                        <div className="left-col">
                                            <p><strong>Terms & Conditions:</strong> Lorem ipsum dolor sit amet, consectetur
                                                adipiscing
                                                elit, sed
                                                do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                        <div className="right-col">
                                            <p><strong>SUBTOTAL:</strong> ${productOrderItemData.totalAmount}</p>
                                            {/* <p><strong>TAX (10%):</strong> $100.00</p>
                            <p><strong>DISCOUNT:</strong> $0.00</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="footer1 text-center mt-4">
                                    <p><strong>Total: ${productOrderItemData.orderAmount}</strong></p>
                                </div>

                                <div className="signature">
                                    <p>AUTHORIZED SIGN</p>
                                </div>

                                <div className="footer1 text-center mt-4">
                                    <p>For any questions contact us at:</p>
                                    <p><a href="mailto:Help@sparks-hvac.com">Help@sparks-hvac.com</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                : null}

            {productOrderData != null ?
                <section>
                    <div>
                        <div className="container mt-5">
                            <header className="d-flex justify-content-between header_weepr">
                                <div className="logo">
                                    <img src="images/logo-white.png" alt="" />
                                </div>
                                <div className="header_text">
                                    <h2>QUOTATION</h2>
                                </div>
                            </header>

                            <div className="all_main_wepper">
                                <div className="client-details">
                                    <strong>QUOTATIONTO:</strong>
                                    <h3>{productOrderData.firstName} {productOrderData.lastName}</h3>
                                    <p><strong>Phone:</strong>{productOrderData.contactNo}</p>
                                    <p><strong>Email:</strong>{productOrderData.emailId}</p>
                                </div>

                                <div className="quotation-details mt-4">
                                    <p><strong>Dear Client,</strong></p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                        labore et
                                        dolore magna aliqua.</p>
                                </div>

                                <div className="mt-4">
                                    <table className="product-table" width="100%" cellPadding="8" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Product Image</th>
                                                <th>Product Name</th>
                                                <th>Service Name</th>
                                                <th>Grade Sqft</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>01</td>
                                                <td>
                                                    {productOrderData?.productPath ? (
                                                        <img
                                                            src={`${productOrderData?.productPath}`}
                                                            alt="Product"
                                                            className="quotation-img"
                                                            style={{ maxWidth: "80px", maxHeight: "80px" }}
                                                        />
                                                    ) : (
                                                        <span style={{ color: "#999", fontSize: "12px" }}>
                                                            No Image
                                                        </span>
                                                    )}
                                                </td>
                                                <td>{productOrderData.productDetail}</td>
                                                <td>{productOrderData.serviceName}</td>
                                                <td>{productOrderData.sizeTypeName}</td>
                                                <td>
                                                    {editingPrice ? (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                            <input
                                                                type="number"
                                                                value={tempPrice}
                                                                onChange={(e) => setTempPrice(e.target.value)}
                                                                onKeyDown={handleKeyPress}
                                                                style={{ width: "80px", padding: "2px 4px", border: "1px solid #ccc", borderRadius: "3px" }}
                                                                autoFocus
                                                            />
                                                            <button
                                                                onClick={handleUpdatePrice}
                                                                disabled={priceLoading}
                                                                style={{
                                                                    padding: "2px 6px",
                                                                    fontSize: "11px",
                                                                    backgroundColor: "#28a745",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "3px",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                ✓
                                                            </button>
                                                            <button
                                                                onClick={handleCancelEdit}
                                                                style={{
                                                                    padding: "2px 6px",
                                                                    fontSize: "11px",
                                                                    backgroundColor: "#dc3545",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "3px",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                            <span>₹ {productOrderData?.custom_price || productOrderData?.selectedSizeDetailsTotalPrice}</span>
                                                            <span
                                                                style={{ cursor: "pointer", fontSize: "14px" }}
                                                                onClick={handleInlineEdit}
                                                                title="Edit price"
                                                            >
                                                                ✏️
                                                            </span>
                                                        </div>
                                                    )}
                                                </td>
                                                {/* <td>
                                                    {isPriceAdded ? (
                                                        <strong>₹ {price}</strong>
                                                    ) : (
                                                        <div className="d-flex align-items-center gap-2 add_price">
                                                            <input
                                                                type="number"
                                                                value={price}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                                placeholder="Enter price"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={handleAddPrice}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                    )}
                                                </td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="terms mt-4">
                                    <div className="terms-conditions-row">
                                        <div className="left-col">
                                            <p><strong>Terms & Conditions:</strong> Lorem ipsum dolor sit amet, consectetur
                                                adipiscing
                                                elit, sed
                                                do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                        <div className="right-col">
                                            {/* <p><strong>SUBTOTAL:</strong> ${productOrderItemData.totalAmount}</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="footer1 text-center mt-4">
                                    {/* <p><strong>Total: ${productOrderItemData.orderAmount}</strong></p> */}
                                </div>

                                <div className="signature">
                                    <p>AUTHORIZED SIGN</p>
                                </div>

                                <div className="footer1 text-center mt-4">
                                    <p>For any questions contact us at:</p>
                                    <p><a href="mailto:Help@sparks-hvac.com">Help@sparks-hvac.com</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                : null}
        </div>
    )
}

export default ProductTemplate;
